import { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routeConfig } from "./config";
import { Layout } from "../components/ui/Layout";

const Router: FC = () => {
  return (
    <Routes>
      {Object.values(routeConfig).map(({ path, element }) => (
        <Route key={path} path={path} element={<Layout>{element}</Layout>} />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Router;
